import React from 'react';
const Icon = ({
  type,
  fontSize,
  color,
  onClick,
  className = '',
  ...rest
}: {
  type: string;
  fontSize?: string | number;
  color?: string;
  className?: string;
  onClick?: () => void;
}) => {
  return (
    <span
      className={`payment-iconfont payment-icon-${type} ${className}`}
      style={{ fontSize, color }}
      onClick={onClick}
      {...rest}
    ></span>
  );
};

export default Icon;
